<!-- Validate Link component -->
<script>
import axios from "axios";
import Loader from "../shared/components/loader/loader.vue";
import Errors from "../shared/components/errors-page/errors.vue";
export default {
  data() {
    return {
      error: false,
      error401: false,
      error500: false,
      errorOther: false,
      networkError:false
    };
  },
  components: {
    Loader,
    Errors,
  },
  created() {
    const formData = {
      pin: this.$route.query.PIN,
      domain: this.$route.query.domain,
      sso_token: this.$route.query.sso_token,
      random: this.$route.query.random,
      timestamp: this.$route.query.timestamp
    };
    if (navigator.onLine) {
      this.networkError=false;
      this.error = false;
    } else {
      this.error = true;
      this.networkError=true
    }
    axios
      .post(`${process.env.VUE_APP_API_URL}/Sso/login`, formData, {
        withCredentials: true,
      })
      .then((res) => {
        this.$root.$i18n.locale = res.data.language;
        this.saveTheme(res.data.subprogramConfigs)
        this.$store.commit("updateProvinceName", res.data.province)
        this.$store.commit("updateUserData", res.data)
        this.$store.commit("updatePin", this.$route.query.PIN)
        this.$store.commit("updateCode", res.data.hierarchyRoleCodeDetails)
        this.$store.commit("setDomain", this.$route.query.domain)
        this.$router.push("/profile");
      })
      .catch((error) => {
        if (error.response !== undefined) {
          if (error.response.data.error.status === 401) {
            this.error = true;
            this.error401 = true;
          } else if (error.response.data.error.status === 500) {
            this.error = true;
            this.error500 = true;
          } else {
            this.error = true;
            this.errorOther = true;
          }
        } else {
          this.error = true;
          this.errorOther = true;
        }
      });
  },
  methods: {
    saveTheme (response) {
      if (!response) return
      var r = document.querySelector(':root');

      if (response.style_brand_primary) {
        r.style.setProperty('--primary-bg', response.style_brand_primary);
        r.style.setProperty('--primary-hover-bg', response.style_brand_primary);
      }
      if (response.style_brand_primary_text) {
        r.style.setProperty('--primary-bg-hover-text', response.style_brand_primary_text);
        r.style.setProperty('--primary-bg-text', response.style_brand_primary_text);
      }
      if (response.style_brand_secondary) {
        r.style.setProperty('--secondary-bg', response.style_brand_secondary);
        r.style.setProperty('--button-hover-bg', response.style_brand_secondary);
      }
      if (response.style_brand_secondary_text) {
        r.style.setProperty('--secondary-bg-text', response.style_brand_secondary_text);
        r.style.setProperty('--button-hover-bg-text', response.style_brand_secondary_text);
      }
      if (process.env.VUE_APP_FONT_URL && process.env.VUE_APP_FONT_NAME) {
        var link = document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('type', 'text/css');
        link.setAttribute('href', process.env.VUE_APP_FONT_URL);
        document.head.appendChild(link);
        r.style.setProperty('--primary-font-family', process.env.VUE_APP_FONT_NAME)
        document.body.style.fontFamily = process.env.VUE_APP_FONT_NAME + " !important"
      }
    }
  },
  name: "vaildate-link",
};
</script>

<!-- Template -->
<template>
  <fragment>
    <loader v-if="!error"></loader>
    <errors
      v-else
      :errorNetworkrErrorprops="this.networkError"
      :error401props="this.error401"
      :error500props="this.error500"
      :errorOtherprops="this.errorOther"
    ></errors>
  </fragment>
</template>

<!-- Style -->
<style lang="scss">
</style>

